import { createFileRoute, redirect } from '@tanstack/react-router';

// The `group_id` and student-focus scoping of the old list have no People
// equivalent; staff reach a congregation's helpers from its group page.
export const Route = createFileRoute('/admin/study-helpers/')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  beforeLoad: () => {
    throw redirect({
      to: '/admin/people/',
      search: { filters: { profile_type: ['STUDY_HELPER'] } },
    });
  },
});
